import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const deleteBooking = async (bookingId: number) => {
    try {
        const token = localStorage.getItem('accessToken'); // Retrieve the token from local storage
        if (!token) {
            throw new Error('No authorization token found');
        }

        console.log(`Attempting to delete booking with ID: ${bookingId}`);
        const response = await axios.delete(`${apiUrl}/Booking/deleteBooking/${bookingId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log('API response:', response.data);
        return response.data;
    } catch (error: any) {
        console.error('Error in deleteBooking API call:', error);
        throw new Error(`Error deleting booking: ${error.message}`);
    }
};

export default deleteBooking;